export default  [
    {
        path: '/kcop',
        name: 'Kcop',
        component: () => import(/* webpackChunkName: "about" */ '../../../views/kcop/kcop.vue'),
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: '/kcop/new',
        name: 'NewKcop',
        component: () => import(/* webpackChunkName: "about" */ '../../../views/kcop/new_kcop.vue'),
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: '/kcop/edit/:id',
        name: 'EditKcop',
        props: true,
        component: () => import(/* webpackChunkName: "about" */ '../../../views/kcop/edit_kcop.vue'),
        meta: { 
          requiresAuth: true
        }
    },
    {
      path: '/kcop/mark/:id',
      name: 'MarkKcop',
      props: true,
      component: () => import(/* webpackChunkName: "about" */ '../../../views/kcop/mark_kcop.vue'),
      meta: { 
        requiresAuth: true
      }
  },
    {
        path: '/kcop/upload/:id',
        name: 'UploadKcop',
        props: true,
        component: () => import(/* webpackChunkName: "about" */ '../../../views/kcop/upload_kcop.vue'),
        meta: { 
          requiresAuth: true
        }
    },
    {
      path: '/kcop_criteria',
      name: 'Kcopcriteria',
      props: true,
      component: () => import(/* webpackChunkName: "about" */ '../../../views/kcopcriteria/kcopcriteria.vue'),
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/kcop_criteria/:id/aspects',
      name: 'Kcopcriteriaaspect',
      props: true,
      component: () => import(/* webpackChunkName: "about" */ '../../../views/kcopcriteria/Kcopcriteriaaspect.vue'),
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/kcop_marks/:kcop_id/:kcop_criteria_id/:expert_id',
      name: 'KcopMarkAspects',
      props: true,
      component: () => import(/* webpackChunkName: "about" */ '../../../views/kcop/kcop_marks_aspects.vue'),
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/kcop_resaults',
      name: 'KcopResaults',
      props: true,
      component: () => import(/* webpackChunkName: "about" */ '../../../views/kcop/kcop_resaults.vue'),
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/summary',
      name: 'Summary',
      props: true,
      component: () => import(/* webpackChunkName: "about" */ '../../../views/kcop/summary.vue'),
      meta: { 
        requiresAuth: true
      }
    },
];